"use strict";

import Vue from "vue";
import Qs from "qs";
import i18n from '@/plugins/i18n'
import axios from "axios";
import store from "../store";
import router from "../router";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = 'http://payplatform-server1.hzxb.pro:9091';
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

const EXPIRE_TIME = 300 * 1000; // 5 分鐘
const CancelToken = axios.CancelToken;
let cache = new Map();

const getExpireTime = () => {
  return new Date().getTime();
};

let config = {
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 90 * 1000, // Timeout
  withCredentials: false, // Check cross-site Access-Control
  transformRequest: [
    function (data) {
      return Qs.stringify({
        ...data
      });
    }
  ]
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    if (config.method === "get") {
      config.params.sysId = store.state.sysId;
    } else if (config.method === "post") {
      config.data.sysId = store.state.sysId;
    }

    if (store.state.token) {
      // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
      config.headers["X-Token"] = store.state.token;
    }

    // 指定API语系
    config.headers["Accept-Language"] = i18n.locale === 'zh' ? 'zh-CN' : 'en-US';

    if (config.cache) {
      const cacheKey = `${config.url}?${Qs.stringify(config.params)}`;
      let source = CancelToken.source();
      config.cancelToken = source.token;
      let data = cache.get(cacheKey);
      let expire_time = getExpireTime();
      if (data && expire_time - data.expire < EXPIRE_TIME) {
        source.cancel(data);
      }
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function (response) {
    if (response.data.code === 206 || response.data.code === 403 || response.data.code === 203) {
      router.push("/login");
    }
    if (response.config.method === "get" && response.config.cache) {
      const cacheKey = `${response.config.url}?${Qs.stringify(
        response.config.params
      )}`;
      let data = {
        expire: getExpireTime(),
        data: response.data
      };
      cache.set(cacheKey, data);
    }

    var contentDisposition = response.headers["content-disposition"];
    if (contentDisposition !== "" && contentDisposition != null) {
      return response;
    }

    return response.data;
  },
  function (error) {
    if (axios.isCancel(error)) return Promise.resolve(error.message.data);
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
